import { useTranslation } from '@frontend/i18n';
import { useCalendarEventsFormTypeShallowStore } from '@frontend/schedule-helpers';
import { Button, PopoverMenu, PopoverMenuItem, usePopoverMenu } from '@frontend/design-system';
import { CalendarEventsEnums } from '../../../Calendar/types';

export const NewEventButton = () => {
  const { t } = useTranslation('schedule');

  const { getTriggerProps: getMenuTriggerProps, getMenuProps, getItemProps } = usePopoverMenu();

  const { setSelectedForm } = useCalendarEventsFormTypeShallowStore('setSelectedForm');

  const handleScheduleCalendarAction = (event: CalendarEventsEnums) => {
    setSelectedForm(event);
  };

  return (
    <>
      <Button
        variant='primary'
        iconName='plus-small'
        size='small'
        aria-label='New Event'
        hoverLabel={t('New Event')}
        hoverLabelPlacement='bottom'
        {...getMenuTriggerProps()}
      />
      <PopoverMenu {...getMenuProps()}>
        <PopoverMenuItem
          {...getItemProps({
            index: 0,
            onClick: () => handleScheduleCalendarAction(CalendarEventsEnums.APPOINTMENT_EVENT),
          })}
        >
          {t('New Appointment')}
        </PopoverMenuItem>
        <PopoverMenuItem
          {...getItemProps({
            index: 1,
            onClick: () => handleScheduleCalendarAction(CalendarEventsEnums.OFFICE_HOURS_OUT_OF_OFFICE_EVENT),
          })}
        >
          {t('New Out of Office Event')}
        </PopoverMenuItem>
      </PopoverMenu>
    </>
  );
};
